'use strict'

// jQuery(document).ready(function($) {
// 	// console.log('JTF Main Theme Script Loaded V2.2.11');
// });
